import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from '../ui/Section';
import { ButtonAnchor, ButtonLink } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { CATALOGO_URL, FINANCIACION_BANNER } from '../../data/brand';
const beneficios = ['Financiación de hasta el 100%', 'Tasa 0% en opciones seleccionadas', 'Asesoramiento personalizado', 'Toma de usado como parte de pago', 'Evaluación rápida, sin compromiso', 'Entregas claras, sin letra chica'];
export function FinanciacionSection() {
  return <Section id="financiacion" className="bg-surface" data-id="element-227" data-mp="1qd5n04dovims">
      <div className="grid items-center gap-10 lg:grid-cols-[1fr_1.05fr] lg:gap-14" data-id="element-228" data-mp="1cep99thesrv5">
        <Reveal data-id="element-229" data-mp="1hd0gdwgbko9o">
          <div data-id="element-230" data-mp="1hch7t6ck7c8b">
            <h2 className="text-3xl font-extrabold leading-[1.1] tracking-tight text-white md:text-[42px]" data-id="element-231" data-mp="1hbxphoizyltr">
              0KM y financiación a tu medida
            </h2>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-mist md:text-[17px]" data-id="element-232" data-mp="5ymx74wigwzz">
              En VCARS te ayudamos a acceder a tu próximo vehículo 0km con opciones de
              financiación pensadas para adaptarse a tus posibilidades. Consultanos por
              planes disponibles, financiación de hasta el 100%, tasa 0% en opciones
              seleccionadas y entregas claras, sin letra chica.
            </p>

            <ul className="mt-7 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-233" data-mp="1j1ao83vtkhog">
              {beneficios.map(b => <li key={b} className="flex items-start gap-2.5" data-id="element-234" data-mp="1x023htmf49e6">
                  <span className="mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full bg-neon/15 text-neon" data-id="element-235" data-mp="1s1qsvgoatuuw">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-236" data-mp="26r530qzp8gbc" />
                  </span>
                  <span className="text-[14.5px] font-medium text-white" data-id="element-237" data-mp="21t3lwblu2r2i">{b}</span>
                </li>)}
            </ul>

            <div className="mt-8 flex flex-wrap gap-3" data-id="element-238" data-mp="2fq0d4e5v6ajx">
              <ButtonLink to="/financiacion" size="lg" data-id="element-239" data-mp="2bs2hashl8q7k">
                Consultar financiación
              </ButtonLink>
              <ButtonAnchor href={CATALOGO_URL} variant="outline" size="lg" data-id="element-240" data-mp="2iruzaejn97b4">
                Ver opciones 0KM
              </ButtonAnchor>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.05} data-id="element-241" data-mp="2sqkge53punqb">
          <div className="overflow-hidden rounded-2xl border border-neon/40" style={{
          boxShadow: '0 0 40px -12px rgba(31,123,255,0.7)'
        }} data-id="element-242" data-mp="2xivi9di0ojli">
            <img src={FINANCIACION_BANNER} alt="VCARS 0KM con financiación tasa 0%: elegí tu marca y tu modelo entre Volkswagen, Chevrolet, Toyota, Fiat, Peugeot, Renault, Ford y Citroën" loading="lazy" className="w-full object-cover" data-id="element-243" data-mp="31k7dpznknz1m" />
          </div>
        </Reveal>
      </div>
    </Section>;
}